module.exports = __webpack_public_path__ + "img/雙人合盤.8008ac9a.png";